import {Layout} from 'antd';
import * as React from 'react';
import {connect} from 'react-redux';
import {Debounce} from 'react-throttle';
import {ThemeProvider} from 'styled-components';
import WindowResizeListener from '../../components/WindowSizeListener';
import AppConfig from '../../config/AppConfig';
import themes from '../../config/themes';
import AppRedux from '../../redux/app/appRedux';
import Sidebar from '../Sidebar/Sidebar';
import Topbar from '../Topbar/Topbar';
import AppRouter from './AppRouter';
import AppHolder from './commonStyle';
import './global.css';
import SagaBreadCrumb from '../../components/utility/breadcrumb';


import SagaAuthRedux, {SagaAuthInitState} from '../../redux/sagaAuth/sagaAuthRedux';


const {Content, Footer} = Layout;

class App extends React.Component<any, any> {
    constructor(props) {
        super(props);
        this.state = {
            loginResponse: null
        };
    }

    public componentDidMount() {
    }

    public componentWillReceiveProps(newProps) {
        const newState = {
            loginResponse: newProps.loginResponse
        };

        this.setState(newState);
    }

    public render() {
        const {url} = this.props.match;
        return (
            <ThemeProvider theme={themes[AppConfig.themeConfig.theme]}>
                <AppHolder>
                    <Layout style={{
                        height: '100vh'
                    }}>
                        <Debounce time='1000' handler='onResize'>
                            <WindowResizeListener
                                onResize={windowSize => this
                                    .props
                                    .toggleAll(windowSize.windowWidth, windowSize.windowHeight)}/>
                        </Debounce> 
                        <Topbar url={url}/>
                        <Layout
                            style={{
                                flexDirection: 'row',
                                overflowX: 'hidden'
                            }}>
                            <Sidebar url={url}/> 
                            <Layout
                                className='isoContentMainLayout'
                                style={{
                                    height: '100vh'
                                }}> 
                                <Content
                                    className='isomorphicContent'
                                    style={{
                                        padding: '70px 0 0',
                                        flexShrink: 0,
                                        background: '#f1f3f6'
                                    }}>
                                    <SagaBreadCrumb/>
                                    <AppRouter url={url}/>
                                </Content>
                                <Footer
                                    style={{
                                        background: '#ffffff',
                                        textAlign: 'center',
                                        borderTop: '1px solid #ededed'
                                    }}>
                                    {AppConfig.siteConfig.footerText}
                                    <p/>
                                    <p>{`Version ${AppConfig.version} ( ${AppConfig.gitShortHash} / ${AppConfig.gitBranch} )`}</p>
                                </Footer>
                            </Layout>
                        </Layout>
                    </Layout>
                </AppHolder>
            </ThemeProvider>
        );
    }
}

const mapStateToProps = (state) => {
    return {loginResponse: state.SagaAuth.loginResponse};
};

const mapDispatchToProps = (dispatch) => {
    return {
        toggleAll: (width, height) => dispatch(AppRedux.toggleAll(width, height)),
        requestLogout: () => dispatch(SagaAuthRedux.requestLogout()),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/containers/App/App.tsx